<app-annual-planning-table quarter="Q1" year="2024"></app-annual-planning-table>